var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { forwardRef } from 'react';
import { extractSupportProps } from '@snack-uikit/utils';
import { TYPE } from './constants';
import styles from './styles.module.css';
export const InputPrivate = forwardRef((_a, ref) => {
    var { name, value = '', onChange, placeholder, id, className, type = TYPE.Text, disabled = false, readonly = false, autoComplete: autoCompleteProp = false, maxLength, min, max, step, onFocus, onBlur, onKeyDown, onPaste, tabIndex = 0, onClick, onMouseDown, spellCheck } = _a, rest = __rest(_a, ["name", "value", "onChange", "placeholder", "id", "className", "type", "disabled", "readonly", "autoComplete", "maxLength", "min", "max", "step", "onFocus", "onBlur", "onKeyDown", "onPaste", "tabIndex", "onClick", "onMouseDown", "spellCheck"]);
    const onChangeHandler = e => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value, e);
    };
    let autoComplete;
    switch (autoCompleteProp) {
        case true:
            autoComplete = 'on';
            break;
        case false:
            autoComplete = 'off';
            break;
        default:
            autoComplete = autoCompleteProp;
            break;
    }
    return (_jsx("input", Object.assign({ name: name, maxLength: maxLength, id: id, className: cn(className, styles.inputPrivate), autoComplete: autoComplete, ref: ref, value: value, onChange: onChangeHandler, placeholder: placeholder, type: type, disabled: disabled, readOnly: readonly, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onPaste: onPaste, tabIndex: tabIndex, onClick: onClick, onMouseDown: onMouseDown, min: min, max: max, step: step, spellCheck: spellCheck, title: '' }, extractSupportProps(rest))));
});
